module.exports = __webpack_public_path__ + "assets/src/style/img/svg/icons/category-art-performance.svg?4370fe8c426b0c47c6aad571ca802384";